import { useEffect, useRef } from 'react'
import classNames from 'classnames'

import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic } from '../../utils'
import styles from './Marquee.module.scss'

function Marquee({ duration, children, isReverseAnimated = false, className }) {
  const { language } = useLanguage()
  const marqueeRef = useRef(null)
  const containerRef = useRef(null)

  useEffect(() => {
    if (duration && isReverseAnimated) {
      const marquee = marqueeRef.current
      const container = containerRef.current
      const containerWidth = container.offsetWidth
      const marqueeWidth = marquee.scrollWidth

      const animationDuration = duration
      const animationKeyframes = `
            @keyframes marquee {
                0% { transform: translateX(${containerWidth}px); }
                50% { transform: translateX(${-marqueeWidth}px); }
                100% { transform: translateX(${containerWidth}px); }
            }
        `

      const styleSheet = document.createElement('style')
      // styleSheet.type = 'text/css'
      styleSheet.innerText = animationKeyframes
      document.head.appendChild(styleSheet)

      marquee.style.animation = `marquee ${animationDuration}s linear infinite`

      return () => {
        document.head.removeChild(styleSheet)
      }
    }
  }, [duration, isReverseAnimated])
  return (
    <div className={classNames(styles.container, className)} ref={containerRef}>
      <div
        className={classNames(styles.marquee, {
          [styles.arabicMarquee]: isArabic(language?.code),
        })}
        ref={marqueeRef}
      >
        {children}
      </div>
    </div>
  )
}

export default Marquee
